export const getters = {
  formeJuridiques(state){
    return state.formeJuridiques.map(item => ({ ...item, libelle: item.code + '-'+ item.libelle   }))
  },

  formeJuridique(state){
    return state.formeJuridique
  }
}